// src/pages/PortfolioPreview.js
import React from "react";
import { Box, Heading, SimpleGrid, Image, Text, Button, VStack, Flex } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom"; // Importer RouterLink
import b5 from "../assets/images/benk/b5.jpg";
import roundtableImage from "../assets/images/rt/roundtable.jpg";
import coffetableImage from "../assets/images/coffetable/coffetable.jpeg";

const previewItems = [
  {
    id: 1,
    title: "Elegant benk",
    imageUrl: b5,
    description: "En nydelig benk i valnøtt, perfekt for gangen eller soverommet."
  },
  {
    id: 2,
    title: "Kaffebord i teak",
    imageUrl: coffetableImage,
    description: "Et enkelt kaffebord - gjenbruk av eldre utebord, perfekt for stuen, verandaen eller hagen."
  },
  {
    id: 3,
    title: "Stuebord i ask",
    imageUrl: roundtableImage,
    description: "Et ovalt stuebord laget i ask, med en unik og tidløs design."
  }
];


const PortfolioPreview = () => {
  return (
    <Box px={{ base: 2, md: 100 }} py={{ base: 8, md: 200 }} bg="#cfe2cf">
      <VStack spacing={{ base: 10, md: 180 }}>
        <Heading as="h2" size={{ base: "md", md: "lg" }} fontWeight="thin" textAlign="center">
          Oppdag sjarmen i skikkelige håndlagde møbler, 
          laget med nøye håndverk og sjel.
          Her blir hvert eneste møbel forma med omtanke
          og kjærlighet til treverket – enkelt, solid og ærlig.
          La deg inspirere av de varme, naturlige tonan som fortell ei historie om vær og vind, 
          fortid og framtid.

          Gjør hjemmet ditt til en plass der hvert møbel gir liv, personlighet og 
          kvalitet som varer – akkurat sånn som det skal være.
        </Heading>
        {/* Flex-konteiner for tekst og knapp på samme rad */}
        <Flex w="100%" align="center" justify="space-between" flexDirection={{ base: "column", md: "row" }} gap={4}>
          <Text fontSize={{ base: "md", md: "xl" }} color="gray.600" textAlign={{ base: "center", md: "left" }}>
            Oppdag et utvalg av mitt arbeid
          </Text>
          <Button
            colorScheme="teal"
            variant="outline"
            onClick={() => (window.location.href = "/portfolio")}
            fontSize={{ base: "md", md: "lg" }}
            py={{ base: 3, md: 4 }}
            px={{ base: 4, md: 6 }}
            minH="44px"
            width={{ base: "100%", md: "auto" }}
          >
            Se hele porteføljen
          </Button>
        </Flex>
      </VStack>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} mt={8}>
        {previewItems.map((item) => (
          <RouterLink to={`/product/${item.id}`} key={item.id} style={{ width: "100%" }}>
            <Box
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
              boxShadow="md"
              _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
              width="100%"
              maxW="100%"
              mb={{ base: 4, md: 0 }}
            >
              <Image
                src={item.imageUrl}
                alt={item.title}
                objectFit="cover"
                width="100%"
                maxW="100%"
                height={{ base: "180px", md: "200px" }}
                maxH={{ base: "180px", md: "200px" }}
                mx="auto"
                mb={2}
              />
              <Box p={4}>
                <Heading as="h3" size={{ base: "sm", md: "md" }} mb={2}>
                  {item.title}
                </Heading>
                <Text mb={2} fontSize={{ base: "sm", md: "md" }}>{item.description}</Text>
              </Box>
            </Box>
          </RouterLink>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default PortfolioPreview;